var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#00A04F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M25 0C21.1914 0 17.5781 0.859375 14.3555 2.38281C14.0235 9.6875 15.3906 17.6758 18.6524 25.5273C22.5977 34.9805 28.6524 42.6367 35.5469 47.6953C44.0821 43.7109 50 35.0391 50 25C50 11.1914 38.8086 0 25 0Z",
    fill: "url(#paint0_radial_2460_2672)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8086 11.1914 50 25 50C30.3516 50 35.293 48.3203 39.3555 45.4688C40.3516 41.4648 40.8789 37.2656 40.8789 32.8906C40.8789 20.1562 36.3867 8.65234 29.1016 0.332031C27.7734 0.117188 26.4062 0 25 0C11.1914 0 0 11.1914 0 25Z",
    fill: "url(#paint1_radial_2460_2672)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5977 23.1055V26.875H20.2344C16.4648 26.875 12.6367 24.8633 12.6367 19.9805C12.6367 15.0977 16.582 13.0664 20.2344 13.0664H22.5977V7.03125H27.3633V13.0664H36.6016V16.8555H27.3633V23.0859H22.5977V16.875H21.0547C19.1992 16.875 17.4609 17.7734 17.4609 20C17.4609 22.207 19.1992 23.125 21.0547 23.125H22.5977V23.1055ZM29.7656 23.1055H27.3633V26.875H28.9648C30.8203 26.875 32.5586 27.7734 32.5586 30C32.5586 32.2266 30.8203 33.125 28.9648 33.125H27.3633V26.8945H22.5977V33.125H13.3594V36.9141H22.5781V42.9688H27.3438V36.8945H29.7461C33.3984 36.8945 37.3438 34.8438 37.3438 29.9805C37.3438 25.1172 33.5352 23.1055 29.7656 23.1055Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2460_2672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.465 9.62852) rotate(2.24275) scale(31.0473 33.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "#C3E237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#ACDE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#87D63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#54CB47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#2CC34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#16B14E",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A04F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2460_2672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.4266 36.6976) scale(40.1957 46.2462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#00552D",
    stopOpacity: 0.805
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#006534",
    stopOpacity: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#007F40",
    stopOpacity: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A04F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg51);
export default __webpack_public_path__ + "static/media/51.51a13fdddfada01bc6db9fbaeff9d876.svg";
export { ForwardRef as ReactComponent };